interface WithExactMessage {
  exact?: boolean;
}

export const withExactMessage = <E extends Error>(
  e: E,
  exact?: boolean,
): E & WithExactMessage => Object.assign(e, { exact });
